module.exports = __webpack_public_path__ + "static/media/ExamplePayment.21a7ab1f.csv";


//////////////////
// WEBPACK FOOTER
// ./src/statics/ExamplePayment.csv
// module id = 2412
// module chunks = 0